import React from "react";
import { formatDist } from "../util/format";
import { useMapContext } from "./MapContext";
import IconJob from "../icons_js/Job.js";
import IconStar from "../icons_js/Star.js";

export default function ListItem({
  provider: {
    dist,
    name,
    address,
    firma,
    webseite,
    key,
    geo: { lat, lng },
    visible,
  },
  setOpen,
  openCard,
}) {
  const { hover, setHover } = useMapContext();
  const isActive = openCard?.key === key;
  const premium = webseite.includes("Premium Freigeschaltet");

  return lat && lng ? (
    <li
      onMouseEnter={() => {
        setHover(key);
      }}
      onMouseLeave={() => {
        setHover(null);
      }}
      style={{
        padding: "8px 10px",
        flexDirection: "column",
        gap: 4,
        borderBottom: "1px solid #eee",
        cursor: "pointer",
        display: visible || isActive ? "flex" : "none",
        // display: "flex",
        background: premium
          ? "#f1e4cc"
          : isActive
          ? "#ffffff"
          : hover === key
          ? "#ebe9eb"
          : "#fafafa",
        transition: "background 200ms ease-out",
      }}
      onClick={() => {
        setOpen(key);
      }}
    >
      <div style={{ display: "flex" }}>
        <div style={{ width: 30, flexShrink: 0 }}>
          {premium ? (
            <IconStar style={{ width: 20, height: 20, color: "#9A231E" }} />
          ) : (
            firma.trim() !== "" && (
              <IconJob style={{ width: 20, height: 20, color: "#aaa" }} />
            )
          )}
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ fontSize: 14 }}>{name}</span>
          <span style={{ fontSize: 11 }}>
            {address} ({formatDist(dist)})
          </span>
        </div>
      </div>
    </li>
  ) : null;
}
